import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esESTranslations from './es-es'

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'es-ES': esESTranslations,
}
